import { InfoCircleOutlined } from '@ant-design/icons'
import { Flex, Tooltip } from 'antd'
import { useTheme } from 'antd-style'

import { dayMonthYearFormatWithDot, formatDate } from 'src/libs'
import { useLocales } from 'src/locales'

import { useHivAnamnesisForm } from '../context/HivAnamnesisFormContext'

type Props = {
  /** Form number of the field, e.g. "4.1". */
  number?: string
  label: string
  /** Path of the field in the form, e.g. `institutions.collectedAt`, to show where its prefill came from. */
  field?: string
}

/** A field label with its form number and, when the field was prefilled, the source of the value. */
export const FieldLabel = ({ number, label, field }: Props) => {
  const { t } = useLocales()
  const palette = useTheme()
  const { getSource } = useHivAnamnesisForm()

  const source = field ? getSource(field) : undefined

  const hint = source
    ? [
        t('hiv_anamnesis.prefilled_from', {
          source: t(`hiv_anamnesis.sources.${source.source}`, {
            defaultValue: source.source
          })
        }),
        source.sourceDate
          ? formatDate(source.sourceDate, dayMonthYearFormatWithDot)
          : undefined
      ]
        .filter(Boolean)
        .join(', ')
    : undefined

  return (
    <Flex gap={6} align="center">
      <span>{number ? `${number}. ${label}` : label}</span>
      {hint && (
        <Tooltip title={hint}>
          <InfoCircleOutlined style={{ color: palette.colorPrimary }} />
        </Tooltip>
      )}
    </Flex>
  )
}
